import React from "react";
import "./Nav.scss";
import { Link } from "react-router-dom";
export default function Nav() {
  return (
    <nav className="navi">
      <ul className="navi__bar">
        <div className="navi__home-wrap">
          <Link to="/">
            <div className="navi__home navi__item"></div>
            <li className="navi__home--text">home</li>
          </Link>
        </div>
        <div className="navi__about-wrap">
          <Link to="/about">
            <div className="navi__about-us navi__item"></div>
            <li className="navi__about--text">about</li>
          </Link>
        </div>
        <div className="navi__contact-wrap">
          <Link to="/contact">
            <div className="navi__contact navi__item"></div>
            <li className="navi__contact--text">contact</li>
          </Link>
        </div>
        <div className="navi__manage-wrap">
          <Link to="/add">
            <div className="navi__manage navi__item"></div>
            <li className="navi__manage--text">Add</li>
          </Link>
        </div>
        <div className="navi__login-wrap">
          <Link to="/login">
            <div className="navi__login navi__item"></div>
            <li className="navi__manage--text">Login</li>
          </Link>
        </div>
      </ul>
    </nav>
  );
}
